import { useAirline } from "../context/AirlineContext";
import { useTheme } from "../context/ThemeContext";
import { resolveIcon } from "../shared/iconMap";
import { AirlineSlideHead } from "../shared/AirlineSlideRenderers";

const SlideCathayServices = () => {
  const { isDark } = useTheme();
  const { airline } = useAirline();
  const brand = airline.brandColor || "#005D63";
  const s = airline?.content?.services || {};
  const partA = s.partA || { label: "", clusters: [] };
  const partB = s.partB || { label: "", clusters: [] };

  const renderCluster = (mod, i, color) => {
    const Icon = resolveIcon(mod.iconName);
    return (
      <div key={i}>
        <div className="flex items-center gap-2 mb-3">
          <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{ backgroundColor: `${color}22` }}>
            <Icon className="w-4 h-4" style={{ color }} />
          </div>
          <span className={`text-[17px] font-semibold tracking-tight ${isDark ? "text-white" : "text-[#1d1d1f]"}`}>{mod.title}</span>
        </div>
        <div className="flex flex-wrap gap-1.5">
          {mod.tags.map((tag, j) => (
            <span
              key={j}
              className="text-[12px] px-2.5 py-1 rounded-full font-medium"
              style={{ backgroundColor: `${color}18`, color: isDark ? color : color }}
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div>
      <AirlineSlideHead
        eyebrow="Services"
        title="Baseline today,"
        accentLine="innovation next."
        airline={airline}
        accent={brand}
      />

      <div className={`mt-10 pt-6 border-t ${isDark ? "border-white/10" : "border-black/10"}`}>
        <div className="k-eyebrow" style={{ color: brand }}>{partA.label}</div>
        <div className="mt-6 grid grid-cols-3 gap-8">
          {(partA.clusters || []).map((svc, i) => renderCluster(svc, i, brand))}
        </div>
      </div>

      <div className={`mt-12 pt-6 border-t ${isDark ? "border-white/10" : "border-black/10"}`}>
        <div className="k-eyebrow" style={{ color: "#3B82F6" }}>{partB.label}</div>
        <div className="mt-6 grid grid-cols-2 gap-10">
          {(partB.clusters || []).map((mod, i) => {
            const color = mod.color === "brand" ? brand : mod.color;
            return renderCluster(mod, i, color);
          })}
        </div>
      </div>
    </div>
  );
};

export default SlideCathayServices;
